import {
    MarketingHeroBanner as MarketingHeroBannerComponent,
    type BannerDataProps,
    type MarketingHeroBannerProps,
    HERO_BANNER_TARGETS,
} from './marketing-hero-banner.react-component';
import {WithCareerAcademiesBanner} from './with-career-academies-banner/with-career-academies-banner.react-component';
import {WithConsolidatedHeroBanner} from './with-consolidated-hero-banner/with-consolidated-hero-banner.react-component';

// TODO(GR-58): revert if control wins:
//   const MarketingHeroBanner = WithCareerAcademiesBanner(MarketingHeroBannerComponent);
const MarketingHeroBanner = WithConsolidatedHeroBanner(
    WithCareerAcademiesBanner(MarketingHeroBannerComponent),
);

// Export the final component from index.ts to break circular dependency
export {MarketingHeroBanner, BannerDataProps, MarketingHeroBannerProps, HERO_BANNER_TARGETS};
